<template>
  <div class="note-entry">
    <div v-if="siteNotes.length">
      <div class="note" v-for="(note, i) in siteNotes" :key="i">
        <span class="title">{{ note.createdAt }}: </span>
        {{ note.body }}
      </div>
    </div>
    <div class="note" v-else>
      None
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    siteNotes: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

.note-entry {
  font-family: Roboto;
  font-size: 11.2px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;

  & .title {
    color: #757575;
  }

  & .note {
    color: rgba(0, 0, 0, 0.87);
    margin-top: 1rem;
  }
}
</style>
